export default "__VITE_ASSET__DRtfgH23__"